"use client"

import Link from "next/link"
import { motion, AnimatePresence } from "framer-motion"
import { useEffect, useState } from "react"
import { FaArrowDown } from "react-icons/fa6"
import { captureClientEvent } from "@/lib/telemetry-client"

export default function StickyMobileCTA() {
    const [isVisible, setIsVisible] = useState(false)
    const [isPastPricing, setIsPastPricing] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const heroHeight = window.innerHeight
            const pricingSection = document.getElementById('preise')
            const pricingSectionBottom = pricingSection
                ? pricingSection.getBoundingClientRect().bottom + window.scrollY
                : Infinity

            const scrollY = window.scrollY

            setIsVisible(scrollY > heroHeight * 0.8)
            setIsPastPricing(scrollY > pricingSectionBottom)
        }

        window.addEventListener('scroll', handleScroll)
        handleScroll()

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <AnimatePresence>
            {isVisible && !isPastPricing && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
                >
                    <div className="bg-gradient-to-t from-slate-900 via-slate-900/95 to-slate-900/0 px-4 pb-4 pt-8">
                        <Link href="#preise" className="block">
                            <button
                                onClick={() => captureClientEvent("sticky_mobile_cta_clicked", { cta: "ticket_kaufen" })}
                                className="group flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 py-4 font-semibold text-slate-900 shadow-lg shadow-amber-500/30 transition-all duration-300 active:scale-95"
                            >
                                <span>Jetzt Ticket kaufen</span>
                                <FaArrowDown className="h-4 w-4 transition-transform group-hover:translate-y-1" />
                            </button>
                        </Link>
                        <p className="mt-2 text-center text-xs text-slate-400">
                            Keine Reservierung nötig
                        </p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
